import { Instance, types } from 'mobx-state-tree';
import { ChatStatsDTO } from 'http-requests/house-chats';
import { RequestStateModel } from '../../general-models';

export const ChatStatsModel = types
  .model('ChatStatsModel', {
    messages_today: types.optional(types.number, 0),
    messages_total: types.optional(types.number, 0),
    created_at: types.optional(types.string, ''),
    requestState: types.optional(RequestStateModel, {}),
  })
  .actions((self) => ({
    setStats(stats: ChatStatsDTO) {
      self.messages_today = stats.messages_today;
      self.messages_total = stats.messages_total;
      self.created_at = stats.created_at;
    },
  }));

export type TChatStats = Instance<typeof ChatStatsModel>;
